import { createResource, type RouteResource } from 'react-resource-router';

import type { ListInfoResponse } from '../../resources';
import { getListInfo } from '../endpoints';

export const globalEscalationsListInfoResource: RouteResource<ListInfoResponse> = createResource({
	type: 'globalEscalationsListInfoResource',
	getKey: () => 'globalEscalationsListInfoResource',
	getData: getListInfo,
	isBrowserOnly: true,
});
